import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { Chip as MuiChip, IconButton } from "@material-ui/core";
import {
  MoreHoriz as ActionsIcon,
  LockOutlined,
  BorderColor,
  Delete,
  Block,
  CheckCircleOutline
} from "@material-ui/icons";
import styled from "styled-components";
import HoverPopover from "../../../components/HoverPopover";
import ClickPopover from "../../../components/ClickPopover";

const DataGrid = styled(ReactDataGrid)`
  &.InovuaReactDataGrid {
    border: none;
    font-family: Nunito, sans-serif;
    font-size: 14px;
    min-height: 550px;
    background: #f5f5f5;
    cursor: pointer;
  }

  .InovuaReactDataGrid__header,
  .InovuaReactDataGrid__row {
    background: #f5f5f5;
  }

  .InovuaReactDataGrid__column-header {
    border: none;
  }
`;

const Chip = styled(MuiChip)`
  font-family: Nunito, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: white;
  height: 26px;
  background-color: ${({ status }) => (status ? "#6ADC35" : "#DC3545")};
`;
const LockContainer = styled.div`
  display: inline-block;
  width: 26px;
  height: 26px;
`;
const LockIcon = styled(LockOutlined)`
  width: 24px;
  height: 24px;
`;

const UserList = ({
  groups,
  loading,
  onOpenDialog,
  onDelete,
  onChangeStatus
}) => {
  const [group, setGroup] = useState({});

  const actions = [
    {
      title: "Editar grupo",
      onClick: data => onOpenDialog(data, true),
      icon: <BorderColor />
    },
    {
      title: "Excluir grupo",
      onClick: data => onDelete(data),
      icon: <Delete />
    },
    {
      title: `${group.active ? "Desativar" : "Ativar"} grupo`,
      onClick: data => onChangeStatus(data, data.active),
      icon: group.active === 1 ? <Block /> : <CheckCircleOutline />
    }
  ];

  const columns = [
    {
      name: "name",
      header: "Nome",
      defaultFlex: 1
    },
    {
      name: "users",
      header: "Usuários",
      headerAlign: "center",
      textAlign: "center",
      defaultFlex: 1
    },
    {
      name: "status",
      header: "Status",
      headerAlign: "center",
      textAlign: "center",
      render: ({ data }) => (
        <Chip status={data.active} label={data.active ? "Ativo" : "Inativo"} />
      )
    },
    {
      name: "actions",
      header: "Ações",
      headerAlign: "center",
      textAlign: "center",
      onClick: (e, row) => {
        setGroup(row.data);
        e.stopPropagation();
      },
      render: ({ data }) => {
        return data.isExternalUser ? (
          <LockContainer>
            <HoverPopover id={data.id} value="Usuário externo">
              <LockIcon />
            </HoverPopover>
          </LockContainer>
        ) : (
          <IconButton>
            <ClickPopover value="Usuário externo" items={actions} data={data}>
              <ActionsIcon />
            </ClickPopover>
          </IconButton>
        );
      }
    }
  ];

  const i18n = Object.assign({}, ReactDataGrid.defaultProps.i18n, {
    pageText: "Página",
    ofText: "de",
    perPageText: "Itens por página",
    showingText: "Mostrando",
    recordsText: "registros"
  });

  return (
    <DataGrid
      idProperty="id"
      showCellBorders={false}
      showZebraRows={false}
      columns={columns}
      dataSource={groups}
      showColumnMenuTool={false}
      resizable={false}
      reorderColumns={false}
      cellSelectionByIndex={false}
      rowHeight={50}
      sortable={false}
      loading={loading}
      enableSelection
      onSelectionChange={row => onOpenDialog(row.data, false)}
      pagination
      limit={20}
      i18n={i18n}
    />
  );
};

UserList.defaultProps = {
  loading: false
};

UserList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default UserList;
